import styles from './Loader.module.scss';

export type Props = {
  outline?: boolean;
};

export default function Loader({ outline = false }: Props) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.loader} data-test="loader">
        <div
          className={outline ? styles['circle-gray'] : styles.circle}
          data-test="loader-circle-1"
        />
        <div
          className={outline ? styles['circle-gray'] : styles.circle}
          data-test="loader-circle-2"
        />
      </div>
    </div>
  );
}
